;(() => {
  function parse(value) {
    if (!value) return null
    const [year, month, day] = value.split("-").map(Number)
    if (!year || !month || !day) return null
    return new Date(Date.UTC(year, month - 1, day))
  }

  function formatIso(date) {
    return date.toISOString().slice(0, 10)
  }

  function addDays(date, days) {
    return new Date(
      Date.UTC(
        date.getUTCFullYear(),
        date.getUTCMonth(),
        date.getUTCDate() + days,
      ),
    )
  }

  function addMonths(date, months) {
    return new Date(
      Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + months, 1),
    )
  }

  function firstOfMonth(date) {
    return new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), 1))
  }

  function sameDate(left, right) {
    return (
      left.getUTCFullYear() === right.getUTCFullYear() &&
      left.getUTCMonth() === right.getUTCMonth() &&
      left.getUTCDate() === right.getUTCDate()
    )
  }

  function today() {
    const now = new Date()
    return new Date(
      Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate()),
    )
  }

  function dayOfWeek(date) {
    const jsDow = date.getUTCDay()
    return jsDow === 0 ? 7 : jsDow
  }

  function monthKey(date) {
    return date.getUTCFullYear() * 12 + date.getUTCMonth()
  }

  function distanceInNights(start, end, maxNights = 0) {
    if (!start || !end) return null
    if (start >= end) return null
    const diffMs = end.getTime() - start.getTime()
    const nights = Math.round(diffMs / 86400000)
    if (!nights || nights < 1) return null
    if (maxNights && nights > maxNights) return null
    return nights
  }

  window.HB = window.HB || {}
  window.HB.UTCDate = {
    parse,
    formatIso,
    addDays,
    addMonths,
    firstOfMonth,
    sameDate,
    today,
    dayOfWeek,
    monthKey,
    distanceInNights,
  }
})()
